import { Dealer, GameListener, Secret } from 'game-logic';

export class RemoteDealer<T> implements Dealer<T> {
  private cachedDisclosedSecrets: Secret[] = [];

  constructor(
    private readonly listener: GameListener,
    private readonly transformSecret: (secret: Secret) => T,
  ) {}

  public async discloseSecrets(indexes: number[], _gameHash: string): Promise<T[]> {
    // Try and match indexes with cached disclosed secrets first
    const disclosedCards = this.matchDisclosedSecrets(indexes, this.cachedDisclosedSecrets);
    if (disclosedCards.length === indexes.length) {
      return disclosedCards;
    }
    // Get secrets from the cloud
    return await this.fetchSecrets(indexes);
  }

  private async fetchSecrets(indexes: number[]): Promise<T[]> {
    const response = await this.listener.discloseSecrets(indexes);
    if (response === undefined) {
      return [];
    }
    this.cacheSecrets(response);

    return this.matchDisclosedSecrets(indexes, response);
  }

  private matchDisclosedSecrets(indexes: number[], disclosedSecrets: Secret[]): T[] {
    const matchedSecrets: T[] = [];
    indexes.forEach((index) => {
      for (const secret of disclosedSecrets) {
        if (secret.index === index) {
          matchedSecrets.push(this.transformSecret(secret));
          break;
        }
      }
    });
    return matchedSecrets;
  }

  private cacheSecrets(secrets: Secret[]): void {
    secrets.forEach((secret) => {
      if (!this.cachedDisclosedSecrets.some((existing) => existing.index === secret.index)) {
        this.cachedDisclosedSecrets.push(secret);
      }
    });
  }
}
